import { segmentAnalytics } from "@pepperstone/analytics-web";

import type {
  ButtonClickEvent,
  HoverEvent,
  InputFocusEvent,
  InputTextChangeEvent,
  LinkClickEvent,
  OptionClickEvent,
  PageViewEvent,
} from "./types";

export const useSegmentAnalytics = () => {
  const trackPageEvent = ({ category, name, properties }: PageViewEvent) => {
    segmentAnalytics?.page(category, name, properties);
  };

  const identifyUser = (userId: string, traits?: Record<string, any>) => {
    segmentAnalytics?.identify(userId, traits);
  };

  const reset = () => {
    segmentAnalytics?.reset();
  };

  const trackButtonClickEvent = ({
    label,
    location,
    extraProperties,
  }: ButtonClickEvent) => {
    segmentAnalytics?.track("Click", {
      ...extraProperties,
      category: "Button",
      label,
      button_location: location,
      button_text: label,
      url: window.location.href,
    });
  };

  const trackExternalLinkClickEvent = ({
    label,
    location,
    extraProperties,
  }: LinkClickEvent) => {
    segmentAnalytics?.track("External link clicked", {
      ...extraProperties,
      category: "External Link",
      label,
      link_location: location,
      link_text: label,
      url: window.location.href,
    });
  };

  const trackMenuClickEvent = ({
    event,
    label,
    location,
    extraProperties,
  }: LinkClickEvent) => {
    const target = event.target as HTMLAnchorElement;
    segmentAnalytics?.track("Menu clicked", {
      ...extraProperties,
      category: "Menu",
      label,
      menu_location: location,
      menu_text: label,
      menu_url: target.href || "pepperstonepartners.com",
      url: window.location.href,
    });
  };

  const trackOptionClickEvent = ({
    label,
    location,
    extraProperties,
  }: OptionClickEvent) => {
    segmentAnalytics?.track("Option clicked", {
      ...extraProperties,
      category: "Option",
      label,
      option_location: location,
      option_text: label,
      url: window.location.href,
    });
  };

  const trackLinkClickEvent = ({
    event,
    label,
    location,
    extraProperties,
  }: LinkClickEvent) => {
    const target = event.target as HTMLAnchorElement;
    segmentAnalytics?.track("Click", {
      ...extraProperties,
      category: "Link",
      label,
      link_location: location,
      link_text:
        (extraProperties && "link_text" in extraProperties
          ? extraProperties.link_text
          : undefined) || label,
      link_url: target.href,
      url: window.location.href,
    });
  };

  const trackHoverEvent = ({
    label,
    location,
    extraProperties,
  }: HoverEvent) => {
    segmentAnalytics?.track("Hover", {
      ...(extraProperties ?? {}),
      category: "Hover",
      label,
      hover_location: location,
      url: window.location.href,
    });
  };

  const trackInputChangeEvent = ({
    label,
    location,
    extraProperties,
  }: InputTextChangeEvent) => {
    segmentAnalytics?.track("Text input", {
      ...extraProperties,
      category: "Input",
      label,
      input_location: location,
      input_text: label,
      url: window.location.href,
    });
  };

  const trackInputFocusEvent = ({
    label,
    location,
    extraProperties,
  }: InputFocusEvent) => {
    segmentAnalytics?.track("Click", {
      ...extraProperties,
      category: "Input",
      label,
      input_location: location,
      url: window.location.href,
    });
  };

  return {
    identifyUser,
    trackPageEvent,
    trackButtonClickEvent,
    trackLinkClickEvent,
    trackExternalLinkClickEvent,
    trackOptionClickEvent,
    trackMenuClickEvent,
    trackHoverEvent,
    trackInputChangeEvent,
    trackInputFocusEvent,
    reset,
  };
};
